import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DateFilterType, Filter, NumberFilterType, StringFilterType, ValueType} from '../filter.type';

@Component({
    selector: 'dmp-filter-table',
    templateUrl: './filter-table.component.html',
    styleUrls: ['./filter-table.component.scss'],
    standalone: false
})
export class FilterTableComponent implements OnInit {
    @Input() filters: Filter[] = [];
    @Input() disable = false;
    @Input() tenant: string;
    @Output() filtersChange = new EventEmitter<Filter[]>();

  constructor() { }



    string_type = Object.values(StringFilterType).map((value) => ({code: value, value}));
    number_type = Object.values(NumberFilterType).map((value) => ({code: value, value}));
    date_type = Object.values(DateFilterType).map((value) => ({code: value, value}));
    readonly stringEmpty = StringFilterType.EMPTY;
    readonly numberEmpty = NumberFilterType.EMPTY;
    readonly dateEmpty = DateFilterType.EMPTY;
    readonly dateRange = DateFilterType.RANGE;
    readonly dateExact = DateFilterType.EXACTLY;

  ngOnInit(): void {
  }

    listToString(list: { code: string, value: string }[] | null | undefined) {
        if (!list || !Array.isArray(list)) {
            return '';
        }
        return list.reduce((acc, curr) => (acc ? acc + ', ' : '') + curr.value, '');
    }

    listType(valueType: ValueType) {
        if (['CIVILITY', 'LANG', 'TAG', 'ACTIVITY_STATUS', 'LOYALTY_STATUS', 'PURCHASE_STATUS', 'CHANNEL'].includes(valueType)) {
            return 'dropdown';
        } else {
            return 'autocomplete';
        }
    }


    onEditComplete() {
        this.handleFilterChanged();
    }

    handleFilterChanged() {
        this.filtersChange.next(this.filters);
    }
}
